export default __webpack_public_path__ + "db31377f46480bb89947d6910608f183.png";